// extracted by mini-css-extract-plugin
export var gradient = "index-old-module--gradient--T-Y7i";
export var gradient_tablet = "index-old-module--gradient_tablet--qaU0I";
export var gradient_mobile = "index-old-module--gradient_mobile--IFoYD";
export var gradientWrapper = "index-old-module--gradient-wrapper--JYjVK";